<template>
  <div id="app">
    <page-header></page-header>
    <!-- <my-home/> -->
    <router-view></router-view>
    <page-footer></page-footer>

  </div>
</template>
<script>
  import myHome from './views/home/index'
  import PageHeader from './views/components/PageHeader.vue'
  import PageFooter from './views/components/PageFooter.vue'
  export default {
    components:{myHome,PageHeader,PageFooter}
  }
</script>
<style lang="less">
  html,body,#app{
    margin: 0;
    height: 100%
  }
  #app{
      margin: 0;
    background-color:#FFFFFF;
      font: 16px Arial, "Microsoft Yahei";
      *{
        box-sizing: border-box;
      }
    .right-box{
      text-align: right;
    }
    }
</style>
